export enum GoalTimeHorizons {
  VERY_SHORT_TERM = 'VERY_SHORT_TERM',
  SHORT_TERM = 'SHORT_TERM',
  MID_TERM = 'MID_TERM',
  LONG_TERM = 'LONG_TERM',
  VERY_LONG_TERM = 'VERY_LONG_TERM',
}
export const timeHorizons = Object.values(GoalTimeHorizons);

export enum GoalTypes {
  CAR = 'CAR',
  BUILD_WEALTH = 'BUILD_WEALTH',
  RETIREMENT = 'RETIREMENT',
  MAJOR_PURCHASE = 'MAJOR_PURCHASE',
  HOUSE = 'HOUSE',
  EDUCATION = 'EDUCATION',
  VACATION = 'VACATION',
  START_A_BUSINESS = 'START_A_BUSINESS',
  WEDDING = 'WEDDING',
  PARENTAL_LEAVE = 'PARENTAL_LEAVE',
  SAFETY_NET = 'SAFETY_NET',
  OTHER = 'OTHER',
  CASH_RESERVE = 'CASH_RESERVE',
  LEGACY = 'LEGACY',
  GROUP = 'GROUP',
  RETIREMENT_INCOME = 'RETIREMENT_INCOME',
}
export const goalTypes = Object.values(GoalTypes);

export enum GoalRiskLevels {
  LEVEL_1 = 'LEVEL_1',
  LEVEL_2 = 'LEVEL_2',
  LEVEL_3 = 'LEVEL_3',
  LEVEL_4 = 'LEVEL_4',
  LEVEL_5 = 'LEVEL_5',
}
export const goalRiskLevels = Object.values(GoalRiskLevels);

export enum GoalStates {
  ACTIVE = 'ACTIVE',
  COMPLETED = 'COMPLETED',
  ARCHIVED = 'ARCHIVED',
}
